import Quill from "quill";
import Constants from "../Constants";
import Helpers from "../Helpers";
import AttachmentBlot from "./AttachmentBlot";
import _ from "lodash";
import message from "components/CustomMessage";
import { getErrorMessage } from 'utils/errorUtil';

Quill.register(AttachmentBlot, true);
class AttachmentHandler {
    constructor(quill, options) {

        _.bindAll(
            this,
            "handlePaste",
            "captureRange"
        )
        this.quill = quill;
        this.options = options;
        this.range = null;

        if (typeof this.options.upload !== "function")
            console.warn(
                "[Missing config] upload function that returns a promise is required"
            );

        this.handler = "attachment";
        this.applyForToolbar();
        this.quill.root.addEventListener('paste', this.handlePaste, false)
    }

    handlePaste(e){
        if(e.clipboardData?.files?.length){
            if(e.clipboardData.files.length/*  !== e.clipboardData.items.length */){
                // this is to prevent if a file is copied from a computer and pasted, then it pastes the file as well as its thumbnail
                // if an image is copied from a doc file along with other texts then it won't be a file
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
            }
            const range = this.quill.getSelection();
            if(range){
                this.range = range;
            }
            const file = this.loadFile(e.clipboardData.files);
            this.embedFile(file);
        }
    }
    appendAttachmentIcon() {
        const _elements = this.quill.getModule("toolbar").container.getElementsByClassName("ql-attachment");

        if (_elements.length > 0) {
            let node = document.createElement("svg");
            node.innerHTML = Helpers.attachmentIconHTML();
            const _element = _elements[0];
            if (!_element) return;

            if (_element?.children.length <= 0) _elements[0].appendChild(node);
        }
    }

    applyForToolbar() {
        var toolbar = this.quill.getModule("toolbar");
        this.appendAttachmentIcon();

        if (toolbar) {
            toolbar.addHandler(this.handler, this.selectLocalFile.bind(this));
            this.quill.container.addEventListener('click', this.captureRange);
            this.quill.container.addEventListener('keyup', this.captureRange);
        }
    }

    captureRange(){
        this.range = this.quill.getSelection();
    }

    selectLocalFile() {
        const _accpepted =
            this.handler === "attachment" ? "*" : `${this.handler}/*`;
        this.range = this.quill.getSelection();
        this.fileHolder = document.createElement("input");
        this.fileHolder.setAttribute("type", "file");
        this.fileHolder.setAttribute("accept", _accpepted);
        this.fileHolder.onchange = this.fileChanged.bind(this);
        this.fileHolder.click();
    }

    insertFileToEditor(url, fileName) {
        const el = this.quill.container.querySelector("#" + this.handlerId);
        if (el) {
            el.setAttribute("data-url", url);
            if (fileName && el.firstElementChild) {
                const anchorTag = el.getElementsByClassName("attachment-name")[0];
                anchorTag.setAttribute("rel", "noopener noreferrer");
                anchorTag.removeAttribute("download");
                anchorTag.href = url;
                const img = new Image();
                img.onload = () => {
                    el.getElementsByClassName("attachment-preview")[0].setAttribute("src", url);
                }
                img.src = url;
            }
        }
    }

    fileChanged() {
        try{
            const file = this.loadFile(this.fileHolder.files);
            if (!file) {
                console.warn(
                    "[File not selected] File is missing, please try to select file again!"
                );
                return;
            }
            this.embedFile(file);
        }
        catch(e){
            message.error(getErrorMessage(e))
        }
    }

    loadFile(files) {

        const file = files[0];
        const extension = file.name.split('.').pop();
        const fileSize = file.size /(1024 ** 2);

        if(file.name.length > 255){
            throw new Error("File name exceeds 255 characters.")
        }
        
        if(['dll','exe'].indexOf(extension) !== -1){
            throw new Error("This type of file is not allowed.")
        }

        if(fileSize > 100){
            throw new Error("File size should not be more than 100MB.")
        }

        this.handlerId = Helpers.generateID();

        const range = this.range;
        this.quill.insertEmbed(
            range?.index??0,
            "attachment",
            `${this.handlerId}${Constants.ID_SPLIT_FLAG}${file.name}`
        );

        return file;
    }

    embedFile(file) {
        return this.options.upload(file).then(
            (url) => {
                this.insertFileToEditor(url, file.name);
                this.removeLoadingClass();
            },
            (error) => {
                console.warn(error.message);
            }
        );
    }

    removeLoadingClass() {
        const el = this.quill.container.querySelector("#" + this.handlerId);
        if (el) {
            const loading = el.getElementsByClassName("loader")[0];
            if (loading) {
                loading.style.display = "none";
            }
        }
    }
}

export default AttachmentHandler;
